/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { Log } from '../../models/log';

export interface PutLog$Params {
   id: string;
   userInfo: string;
}

export function putLog(
   http: HttpClient,
   rootUrl: string,
   params: PutLog$Params,
   context?: HttpContext
): Observable<StrictHttpResponse<Array<Log>>> {
   const rb = new RequestBuilder(rootUrl, putLog.PATH, 'put');
   if (params) {
      rb.path('id', params.id, {});
      rb.query('userInfo', params.userInfo, {});
   }

   return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
         return r as StrictHttpResponse<Array<Log>>;
      })
   );
}

putLog.PATH = '/api/weather/log/{id}/userInfo';
